module.exports = __webpack_public_path__ + "static/img/diyiimgre.43d1d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyiimgre.png
// module id = G+fz
// module chunks = 5